import { useEffect, useState } from "react";
import { api } from "../api";

interface Props {
  hasImportedLocal: boolean;
  onImported: () => void;
}

const LEGACY_KEY = "crm_ss_v4";
const DISMISS_KEY = "crm_ss_v5_imported";

export function ImportBanner({ hasImportedLocal, onImported }: Props) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    if (hasImportedLocal) { localStorage.setItem(DISMISS_KEY, "1"); return; }
    const raw = localStorage.getItem(LEGACY_KEY);
    if (!raw) return;
    try {
      const recs = JSON.parse(raw);
      if (Array.isArray(recs) && recs.length) setCount(recs.length);
    } catch {}
  }, [hasImportedLocal]);

  if (count == null) return null;

  async function doImport() {
    const raw = localStorage.getItem(LEGACY_KEY);
    if (!raw) return;
    try {
      const recs = JSON.parse(raw);
      const r = await api.importRecords(recs);
      if (r) alert(`Importados: ${r.imported} · Ignorados (duplicados): ${r.skipped}`);
      localStorage.removeItem(LEGACY_KEY);
      localStorage.setItem(DISMISS_KEY, "1");
      setCount(null);
      onImported();
    } catch (e: any) { alert("Erro ao importar: " + e.message); }
  }

  async function dismiss() {
    try { await api.dismissImport(); } catch {}
    localStorage.setItem(DISMISS_KEY, "1");
    setCount(null);
  }

  return (
    <div className="banner" style={{ background: "#FAEEDA", borderColor: "#EF9F27", color: "#854F0B" }}>
      <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
      Encontramos {count} prospecções salvas neste navegador.
      <button className="btn-sm" style={{ marginLeft: "auto" }} onClick={doImport}>Importar para a nuvem</button>
      <button className="btn-sm" onClick={dismiss}>Descartar</button>
    </div>
  );
}
